function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Invoice_2_",
  transform: "translate(-749.3 -534.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_721",
  "data-name": "Trazado 721",
  d: "M771.633,534.5v30.708H750.7a1.406,1.406,0,0,1-1.4-1.4V541.479a6.972,6.972,0,0,1,6.979-6.979Z",
  transform: "translate(0)",
  fill: "#3d8eff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_722",
  "data-name": "Trazado 722",
  d: "M828.758,534.5H781.3a6.972,6.972,0,0,1,6.979,6.979v46.063A13.971,13.971,0,0,0,802.237,601.5h33.5V541.479A6.972,6.972,0,0,0,828.758,534.5Z",
  transform: "translate(-25.021)",
  fill: "#66a8fb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_723",
  "data-name": "Trazado 723",
  d: "M935.346,777.7a15.436,15.436,0,0,1-15.354,13.958H883.7A15.36,15.36,0,0,0,898.989,777.7Z",
  transform: "translate(-105.088 -190.158)",
  fill: "#3d8eff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_568",
  "data-name": "Grupo 568",
  transform: "translate(768.842 541.501)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_724",
  "data-name": "Trazado 724",
  d: "M846.337,578.29l-2.835-.938a2.652,2.652,0,0,1,.851-5.169h.262a2.7,2.7,0,0,1,2.661,2.726v.065a1.34,1.34,0,0,0,1.352,1.33h.044a1.448,1.448,0,0,0,1.4-1.461,5.478,5.478,0,0,0-4.187-5.3V568a1.4,1.4,0,1,0-2.792,0v1.548a5.435,5.435,0,0,0-.458,10.447l2.835.938a2.652,2.652,0,0,1-.851,5.169h-.262a2.672,2.672,0,0,1-2.661-2.661v-.131a1.34,1.34,0,0,0-1.352-1.33H840.3a1.448,1.448,0,0,0-1.4,1.461,5.478,5.478,0,0,0,4.188,5.3v1.549a1.4,1.4,0,0,0,2.792,0v-1.549a5.435,5.435,0,0,0,.458-10.447Z",
  transform: "translate(-838.9 -566.6)",
  fill: "#004185"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_725",
  "data-name": "Trazado 725",
  d: "M928.842,582.092H910.7a1.4,1.4,0,0,1,0-2.792h18.146a1.4,1.4,0,0,1,0,2.792Z",
  transform: "translate(-893.946 -576.53)",
  fill: "#004185"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_726",
  "data-name": "Trazado 726",
  d: "M928.842,620.492H910.7a1.4,1.4,0,0,1,0-2.792h18.146a1.4,1.4,0,0,1,0,2.792Z",
  transform: "translate(-893.946 -606.555)",
  fill: "#004185"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_727",
  "data-name": "Trazado 727",
  d: "M928.842,658.892H910.7a1.4,1.4,0,0,1,0-2.792h18.146a1.4,1.4,0,0,1,0,2.792Z",
  transform: "translate(-893.946 -636.58)",
  fill: "#004185"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_728",
  "data-name": "Trazado 728",
  d: "M873.8,697.292H840.3a1.4,1.4,0,1,1,0-2.792h33.5a1.4,1.4,0,1,1,0,2.792Z",
  transform: "translate(-838.9 -666.605)",
  fill: "#004185"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_729",
  "data-name": "Trazado 729",
  d: "M873.8,735.692H840.3a1.4,1.4,0,0,1,0-2.792h33.5a1.4,1.4,0,1,1,0,2.792Z",
  transform: "translate(-838.9 -696.63)",
  fill: "#004185"
})));

var SvgDataCredit = function SvgDataCredit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80.958,
    height: 67,
    viewBox: "0 0 80.958 67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataCredit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dataCredit.1e61880b.svg";
export { ForwardRef as ReactComponent };